import { render, staticRenderFns } from "./WaitTodaymodel.vue?vue&type=template&id=bab06622&scoped=true&"
import script from "./WaitTodaymodel.vue?vue&type=script&lang=js&"
export * from "./WaitTodaymodel.vue?vue&type=script&lang=js&"
import style0 from "./WaitTodaymodel.vue?vue&type=style&index=0&id=bab06622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab06622",
  null
  
)

export default component.exports